import React, { useEffect } from "react";
import styled from "styled-components";
//
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

import { mobile, mobileM, tablet } from "../../responsive";
const imgSavoirFaire =
  "https://images.pexels.com/photos/6903149/pexels-photo-6903149.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
// the above img https://www.pexels.com/fr-fr/photo/lumineux-centrale-lampe-cuisine-6903160/
//
//
// "https://images.pexels.com/photos/3356416/pexels-photo-3356416.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
// "https://images.pexels.com/photos/7120210/pexels-photo-7120210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
//
//
const SavoirFaireContainer = styled.div`
  padding-top: 70px;
  width: 100%;
  min-height: 60vh;

  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: rgb(243, 243, 243);

  //
  ${mobile({ width: "100%", flexDirection: "column" })}
  ${mobileM({ flexDirection: "column" })}
  ${tablet({ flexDirection: "column" })}
`;
//

// ** LEFT **
//
const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

//
//

const ImgContainer = styled.div``;
const ImgBox = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  overflow: hidden;

  //
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    aspect-ratio: 1/1;

    //
    ${mobile({ borderRadius: "0" })}
    ${mobileM({ borderRadius: "0" })}
  ${tablet({ borderRadius: "0" })}

   //
  }
`;
//
//
const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`;
//
const Container = styled.div`
  padding: 50px;
  ${mobile({
    padding: "70px 30px",
  })}
  ${mobileM({
    padding: "70px 40px",
  })}
   ${tablet({
    padding: "70px 50px",
  })}
  //
  //
  h1,
  h2,
  h3 {
    padding: 0 0 0 0;
    color: #0f0f0ff6;
    font-size: calc(6px + 1vmin);
    text-transform: uppercase;
    font-family: "Poppins-light";
    letter-spacing: 1px;
  }
  h2 {
    margin: 0 50% 0 0;
    padding: 10px 0 30px 0;
    color: #0f0f0f;
    font-size: calc(10px + 4vmin);
    text-transform: Capitalize;
    line-height: 42px;
    ${mobile({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
    ${mobileM({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
        ${tablet({
      padding: "35px 0 50px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
  }
  p {
    max-width: 80%;
    color: #0f0f0fcf;
    margin: 0 0 40px 0;
    font-size: calc(7px + 1vmin);
    ${mobile({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "25px",
    })}
    ${mobileM({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "calc(19px + 1.4vmin)",
    })}
      ${tablet({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "calc(19px + 1.4vmin)",
    })}
  }

  button {
    padding: 13px 35px;
    margin: 0;
    font-weight: 600;
    font-size: calc(7px + 1vmin);
    border-radius: 100px 100px 100px 100px;
    background-color: transparent;
    border: 1.5px solid #0f0f0f;
    color: #0f0f0f;
    text-transform: uppercase;

    transition: 0.3s ease-in-out;
    &:hover {
      padding: 13px 35px;
      margin: 0;
      background-color: rgb(10, 10, 10);
      border: 1.5px solid rgb(24, 24, 24);
      font-weight: 100;
      color: #eeeeee;
    }
  }
`;

//
//

const About = () => {
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  return (
    <>
      <SavoirFaireContainer>
        <Left>
          <ImgContainer>
            <ImgBox>
              <motion.img
                data-aos="fade-right"
                whileHover={{ scale: 1.1 }}
                onHoverStart={(eImg) => {}}
                onHoverEnd={(eImg) => {}}
                src={imgSavoirFaire}
              />
            </ImgBox>
          </ImgContainer>
        </Left>
        <Right>
          <Container>
            {" "}
            <h1>The Project</h1>
            <h2>Camaie Store</h2>
            <p>
              The creation of this e-commerce website was a journey of learning
              and exploration in React, SCSS, Styled Components, AOS, Framer
              Motion, and HTML.
              <br></br>
              <br></br>
              The goal was to visually represent the creator's practice with
              these technologies, as well as to bring a touch of innovation to
              the website with the use of Blender and THREEjs. It took the
              creator close to 7 months to master the basics of Blender and
              create the stunning 3D render of the Lounge Chair featured on the
              homepage.
              <br></br>
              <br></br>
              The addition of THREEjs allowed the creator to bring their 3D
              models to life on the website, providing a unique and immersive
              experience for users. Although the creator acknowledges that there
              is so much to learn, she believes that this project is a step in
              the right direction.
              <br />
              <br />
            </p>
            <button>Read More</button>
          </Container>
        </Right>
      </SavoirFaireContainer>
    </>
  );
};

export default About;
